import { Skeleton } from "@mui/material";
import clsx from "clsx";
import he from "he";
import { useEditor } from "@smartfire/js-block-engine";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../button/block";
import style from "./style.module.scss";
import { traducButton } from "../../shared/tools";

export const Product = ({
  product,
  className = null,
  listInsert = false,
  buttonLabel = null,
  buttonColor = null,
  buttonHoverColor = null,
  buyWithAmazon = false,
  ...props
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const { isEditing } = useEditor();
  const Wrapper = !isEditing ? "a" : "div";

  // React i18next
  const { t } = useTranslation();

  useEffect(() => {
    if (product?.image?.url) {
      const img = new Image();
      img.src = product.image.url;
      img.onload = () => setImageLoaded(true);
      img.onerror = () => {
        setImageLoaded(true);
      };
    }
  }, [product?.image?.url]);

  return (
    <div className={clsx(className, style.container)}>
      <Wrapper
        className={clsx(style.product, listInsert && style.listInsertProduct)}
        href={!isEditing ? product.link : undefined}
      >
        <div className={style.imageContainer}>
          {product?.image?.url && (
            <>
              {!imageLoaded && (
                <Skeleton
                  variant="rectangular"
                  className={clsx(style.skeletonImage, style.mainImage)}
                />
              )}
              <img
                className={style.mainImage}
                alt={
                  product?.image?.alt ||
                  `${
                    product.brand?.title
                      ? he.decode(product.brand?.title) + " - "
                      : ""
                  }${he.decode(product.title)}`
                }
                src={product?.image?.url}
                style={{ display: imageLoaded ? "block" : "none" }}
                loading="lazy"
              />
            </>
          )}
        </div>
        <div className={style.info}>
          <span className={style.brand}>
            {product?.brand?.name && he.decode(product.brand.name)}
          </span>
          <p className={style.title}>
            {product.title && he.decode(product.title)}
          </p>
        </div>
        <Button
          tagName="div"
          text={buttonLabel ? buttonLabel : traducButton(t, "Buy now")}
          className={style.buy}
          showInspector={false}
          color={buttonColor || style.darkGreen}
          colorHover={buttonHoverColor || style.darkerGreen}
        />
        {!buyWithAmazon && product.enableBuyOnline && product.buyOnlineLink && (
          <Button
            className={style.buy}
            tagName="div"
            text={product.buyOnlineLink.text || t("Buy online")}
            target="_blank"
            showInspector={false}
            onClick={(e) => {
              e.preventDefault();
              if (product.buyOnlineLink.link)
                window.location.href = product.buyOnlineLink.link;
            }}
          />
        )}
      </Wrapper>
    </div>
  );
};

export default Product;
